import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-accept-in-group-dialog',
  templateUrl: './accept-in-group-dialog.component.html',
  styleUrls: ['./accept-in-group-dialog.component.scss']
})
export class AcceptInGroupDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
  }

  accept() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close();
  }
}
